import { render, staticRenderFns } from "./DistributionOfLearnersIeltsScoreChart.vue?vue&type=template&id=01d2bfae&scoped=true&"
import script from "./DistributionOfLearnersIeltsScoreChart.vue?vue&type=script&lang=js&"
export * from "./DistributionOfLearnersIeltsScoreChart.vue?vue&type=script&lang=js&"
import style0 from "./DistributionOfLearnersIeltsScoreChart.vue?vue&type=style&index=0&id=01d2bfae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d2bfae",
  null
  
)

export default component.exports